import React, { useState, useEffect, useReducer, useRef } from 'react';
import { SFuncModal } from 'shj-components'
import { Form, Button, Divider, Row, Col, Switch, Input, message } from 'antd';
import { receiptRulesPlanRulesBranchPlan } from '@/services/fmsConfig'
export function modalAddPlanFn({ fn, ...rest }) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `新增分期计划`,
    width: 600,
    vanish: true,
    content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}
const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
  const [form] = Form.useForm();
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  useEffect(() => {
    initFn();
  }, []);

  const initFn = () => {
    const { planTypeName, enabled } = rest;
    if (rest?.id) {
      // 回显数据
      form.setFieldsValue({
        planTypeName,
        enabled,
      });
    }
  };
  // 保存
  const onFinish = (values: any) => {
    let newValues = { ...values };
    newValues.planMainId = rest.planMainId;
    newValues.enabled = newValues.enabled ? newValues.enabled : false;
    setAddOrEditFooterLoading(true);
    receiptRulesPlanRulesBranchPlan({ ...newValues })
      .then((resp: any) => {
        setAddOrEditFooterLoading(false);
        message.info(resp?.message || '操作成功');
        onClose();
        fn && fn();
      })
      .finally(() => {
        setAddOrEditFooterLoading(false);
      });
  };
  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
  };
  return (
    <div style={{ padding: 15 }}>
      <Form form={form} onFinish={onFinish}>
        <Form.Item
          label="方案名称"
          name="planTypeName"
          {...formItemLayout}
          rules={[{ required: true, message: '请输入方案名称' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="是否主合同分期"
          {...formItemLayout}
          name="enabled"
        >
          <Switch />
        </Form.Item>
        <Form.Item>
          <Row>
            <Col span={24}>
              <Divider />
            </Col>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button htmlType="button" onClick={onClose} style={{ marginLeft: '8px' }}>
                取消
              </Button>
              <Button type="primary" htmlType="submit" style={{ margin: '0 8px' }} loading={addOrEditFooterLoading}>
                保存
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </div>
  );
};
